module.exports = __webpack_public_path__ + "img/fatherhood_15.926371d2.jpg";